import { handleActions } from 'redux-actions';
import { logoutSuccess } from 'ducks/auth/actions';

import {
  branchesSuccess,
  branchOptionsSuccess,
  branchSuccess,
  updateBranchStatusSuccess,
  updateBranchSuccess,
} from './actions';

import initialState from './states';

export default handleActions(
  {
    [branchesSuccess](state, { payload }) {
      return {
        ...state,
        list: payload,
      };
    },
    [branchSuccess](state, { payload }) {
      return {
        ...state,
        info: {
          ...state.info,
          [payload.branchID]: payload,
        },
      };
    },
    [branchOptionsSuccess](state, { payload }) {
      return {
        ...state,
        options: payload,
      };
    },
    [updateBranchSuccess](state, { payload: { payload, branchID } }) {
      return {
        ...state,
        info: {
          ...state.info,
          [branchID]: {
            ...state.info[branchID],
            ...payload,
          },
        },
      };
    },
    [updateBranchStatusSuccess](state, { payload: { status, branchID } }) {
      return {
        ...state,
        info: {
          ...state.info,
          [branchID]: {
            ...state.info[branchID],
            status,
          },
        },
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
